"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonSectionDoubled = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{section: JQuery; params: { id: string}}} control
     */
    function EpsilonSectionDoubled(section) {
        /**
         * save instance of section
         */
        this.section = section;
        /**
         * Move out of the ugly list, this has overflow hidden and we can`t display it properly
         */
        this.createParent();
        /**
         * Append new sections to parent
         */
        this.section.container.appendTo(this.parent);
        /**
         * Handle Events
         */
        this.handleEvents();
    }
    EpsilonSectionDoubled.prototype.handleEvents = function () {
        var self = this;
        var section = this.section;
        /**
         * Close sections
         */
        section.container.on('click', '.epsilon-close-doubled-section', function (e) {
            e.preventDefault();
            jQuery('body').removeClass('adding-doubled-section');
            jQuery('body').find('.doubled-section-opened').removeClass('doubled-section-opened');
        });
        /**
         * Open sections
         */
        section.headContainer.on('click', function (e) {
            var opened, strippedIdHead, strippedIdContainer;
            e.preventDefault();
            /**
             * We need to close everything on click
             * @type {*|{}}
             */
            opened = self.parent.find('.doubled-section-opened');
            if (opened.length) {
                opened.removeClass('doubled-section-opened');
            }
            if (jQuery('body').hasClass('adding-doubled-section')) {
                strippedIdHead = jQuery(this).attr('id');
                if ('undefined' !== typeof strippedIdHead) {
                    strippedIdHead = strippedIdHead.replace('accordion-section-', '');
                }
                strippedIdContainer = opened.attr('id');
                if ('undefined' !== typeof strippedIdContainer) {
                    strippedIdContainer = strippedIdContainer.replace('sub-accordion-section-', '');
                }
                if (strippedIdContainer === strippedIdHead) {
                    jQuery('body').removeClass('adding-doubled-section');
                }
            }
            else {
                jQuery('body').addClass('adding-doubled-section');
            }
            jQuery.each(section.container, function () {
                if (jQuery(this).is('li')) {
                    return;
                }
                jQuery(this).addClass('doubled-section-opened');
            });
        });
    };
    /**
     * Create a parent container
     */
    EpsilonSectionDoubled.prototype.createParent = function () {
        var parent = jQuery('.wp-full-overlay').find('.doubled-section-parent');
        if (!parent.length) {
            jQuery('.wp-full-overlay').append('<div class="doubled-section-parent"></div>');
            parent = jQuery('.wp-full-overlay').find('.doubled-section-parent');
            this.parent = parent;
        }
        this.parent = parent;
    };
    return EpsilonSectionDoubled;
}());
exports.EpsilonSectionDoubled = EpsilonSectionDoubled;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/sections/section-doubled.ts
// module id = 44
// module chunks = 0